import { render, staticRenderFns } from "./Supporters.vue?vue&type=template&id=0ed716ad&scoped=true&"
import script from "./Supporters.vue?vue&type=script&lang=ts&"
export * from "./Supporters.vue?vue&type=script&lang=ts&"
import style0 from "./Supporters.vue?vue&type=style&index=0&id=0ed716ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed716ad",
  null
  
)

export default component.exports